export default [
  100003, 100004, 100005, 100006, 100007, 100008, 100119, 100122, 100123, 100125,
  100127, 100128, 100130, 100131, 100133, 100135, 100137, 100139, 100140, 100141,
  100144, 100420, 100421, 100422, 100423, 100424, 100425, 100426, 100427, 100428,
  100429, 100430, 100431, 100432, 100434, 100435, 100436, 100437, 100440, 100441,
  100442, 100443, 100444, 100445, 100446, 100447, 100448, 100450, 100451, 100452,
  100453, 100661, 100665, 100666, 100868, 100869, 100870, 100871, 100872, 100873,
  100874, 100875, 100878, 100879, 100880, 100884, 100891, 100892, 100893, 100894,
  100895, 100896, 100897, 100898, 100901, 100902, 100904, 100905, 101213, 101607,
  101608, 101609, 101610, 101611, 101612, 101613, 101614, 101615, 101616, 101617,
  101618, 101619, 101620, 101627, 101628, 101629, 101630, 101631, 101632, 101633,
  101634, 101635, 101636, 101637, 101638, 101639, 101640, 101641, 101642, 101643,
  101644, 101645, 101646, 101647, 101658, 101669, 101670, 101671, 101672, 101673,
  101674, 101675, 101676, 102003, 102004, 102005, 102006, 102007, 102008, 102009,
  102010, 102012, 102013, 102014, 102015, 102016, 102029, 102030, 102031, 102035,
  102178
]



// WEBPACK FOOTER //
// ./src/storage/shopeeAnvisaCategories.js